import { Dispatch, SetStateAction } from "react";
import { z } from "zod";
import { ErrorType } from "../../types/common-type";

export type AddNewInviteForm = z.infer<typeof addNewInviteSchema>;

export const addNewInviteSchema = z.object({
  first_name: z.string().min(1, "First name is required"),
  middle_name: z.string().optional(),
  last_name: z.string().min(1, "Last name is required"),

  date_of_birth: z.string().min(1, "Date of birth is required"),

  gender: z.string().min(1, "Gender is required"),

  father_name: z.string().min(1, "Father name is required"),

  applicant_designation: z.string().min(1, "Applicant designation is required"),

  applicant_department: z.string().min(1, "Applicant department is required"),

  applicant_joining_date: z
    .string()
    .min(1, "Applicant joining date is required"),

  recruiter_id: z.string().min(1, "Recruiter ID is required"),

  recruiter_name: z.string().min(1, "Recruiter name is required"),

  upload_url: z.string().min(1, "Document upload is required"),

  address_line1: z.string().min(1, "Address Line 1 is required"),

  address_line2: z.string().optional(),

  city: z.string().min(1, "City is required"),

  state: z.string().min(1, "State is required"),

  pin_code: z
    .string()
    .min(1, "Pin code is required")
    .regex(/^\d{6}$/, "Pin code must be 6 digits"),

  country: z.string().min(1, "Country is required"),

  period_from: z.string().min(1, "Period From is required"),

  period_to: z.string().min(1, "Period To is required"),

  type_of_account: z.string().min(1, "Type of account is required"),
});

export const Validation_addNewInvite = <T extends z.ZodTypeAny>({
  data,
  schema,
  setErrors,
}: {
  data: z.infer<T>;
  schema: T;
  setErrors: Dispatch<SetStateAction<ErrorType>>;
}) => {
  const result = schema.safeParse(data);

  if (!result.success) {
    const fieldErrors = Object.fromEntries(
      Object.entries(result.error.flatten().fieldErrors).map(([key, value]) => [
        key,
        Array.isArray(value) ? (value[0] ?? "") : "",
      ]),
    );
    setErrors(fieldErrors);
    return false;
  }
  setErrors({});
  return true;
};
